export default "__VITE_ASSET__U948R9dE__"